import { render, staticRenderFns } from "./personal-details-step.vue?vue&type=template&id=b27628e4"
import script from "./personal-details-step.vue?vue&type=script&lang=js"
export * from "./personal-details-step.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports